import { Button, HStack, Heading, Text, VStack } from "@chakra-ui/react"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
// import useTranslate from "@pathwright/ux/src/components/lng/useTranslate"
import React from "react"

type DiscussionResponseDeleteProps = {
  onDeleteResponse: () => void
  onCancelDelete: () => void
}

/**
 * React conversion of discussion-response-delete.js
 * Confirmation dialog for deleting a discussion response
 *
 * Original Marionette view functionality:
 * - Shows "Are you sure?" confirmation message
 * - "This action cannot be undone" warning
 * - Delete button (danger style) and Cancel link
 * - Triggers "delete:response" and "cancel:delete:response" events
 */
function DiscussionResponseDelete({
  onDeleteResponse,
  onCancelDelete
}: DiscussionResponseDeleteProps) {
  const { t } = useTranslate()

  const handleDelete = () => {
    onDeleteResponse()
  }

  const handleCancel = (e: React.MouseEvent) => {
    e.preventDefault()
    onCancelDelete()
  }

  return (
    <VStack
      className="discussion-response-delete-view"
      align="center"
      justify="center"
      p={4}
      pos="absolute"
      inset={0}
      bg="whiteAlpha.600"
      backdropFilter="blur(4px)"
      w="full"
      gap={1}
    >
      <Heading as="h1" size="md" m={0}>
        {t("discussion.response_delete.are_you_sure")}
      </Heading>

      <Text color="gray.600" m={0}>
        {t("discussion.response_delete.cannot_undo")}{" "}
      </Text>

      <HStack gap={2} className="archive-action">
        <Button
          colorPalette="red"
          variant="solid"
          size="sm"
          onClick={handleDelete}
          className="delete-response"
        >
          {t("discussion.response_delete.yes_delete")}
        </Button>

        <Text color="gray.500">{t("discussion.response_delete.or")}</Text>

        <Button
          variant="plain"
          onClick={handleCancel}
          className="cancel-delete-response"
          background="none"
        >
          {t("discussion.response_delete.cancel")}
        </Button>
      </HStack>
    </VStack>
  )
}

export default DiscussionResponseDelete
